/* Components, sorted alphabetically */
import AppHeaderMobile from '../app-header-mobile'
import AppLeftSidebar from '../app-left-sidebar'
import AppLoader from '../app-loader'
import AppModalPost from '../app-modal-post'
import AppNav from '../app-nav'
import AppNavMobile from '../app-nav-mobile'
import AppPageClients from '../app-page-clients'
import AppPageCms from '../app-page-cms'
import AppPageContact from '../app-page-contact'
import AppPageEncyclopediaDetail from '../app-page-encyclopedia-detail'
import AppPageEncyclopediaComingSoon from '../app-page-encyclopedia-coming-soon'
import AppPageHome from '../app-page-home'
import AppPageMap from '../app-page-map'
import AppPageProduct from '../app-page-product'
import AppPageProject from '../app-page-project'
import AppPageShop from '../app-page-shop'
import AppPageSearch from '../app-page-search'
import AppPageSelection from '../app-page-selection'
import AppPageTeam from '../app-page-team'
import AppPage404 from '../app-page-404'
import AppProjectModal from '../app-project-modal'
import AppTooltipSelection from '../app-tooltip-selection'
import CoreFetch from '../core-fetch'

/* Mixins, sorted alphabetically */
import eventHub from '../../mixins/eventHub'

/* Router */
import router from '../../router'

/* Utilities, sorted alphabetically */
import getCookies    from '../../utils/getCookies.js'
import setCookies    from '../../utils/setCookies.js'
import VirtualScroll from '../../utils/virtual-scroll'

export default
{
    router,

    components:
    {
        AppHeaderMobile,
        AppLeftSidebar,
        AppLoader,
        AppModalPost,
        AppNav,
        AppNavMobile,
        AppPageClients,
        AppPageContact,
        AppPageEncyclopediaDetail,
        AppPageEncyclopediaComingSoon,
        AppPageHome,
        AppPageCms,
        AppPageMap,
        AppPageProduct,
        AppPageProject,
        AppPageSearch,
        AppPageSelection,
        AppPageShop,
        AppPageTeam,
        AppPage404,
        AppProjectModal,
        AppTooltipSelection,
        CoreFetch
    },

    watch:
    {
        $route: 'onRouteChange'
    },

    data()
    {
        return {
            window:
            {
                width: 0,
                height: 0
            },

            scrollTop: 0,
            currScrollTop: 0,

            virtualScroll: 0,

            scrollDirection: 1,

            isUserScrolling: false,

            isNavActive: false,
            isDataLoaded: false,
            isGlobalDataLoaded: false,
            isLoaderActive: false,
            isModalPostActive: false,
            isModalDataLoaded: false,
            isMobileNavActive: false,
            isSmallScreen: false,
            isSwitchinModal: false,
            isFirstLoading: true,
            isVirtualScrollActive: false,
            isTooltipVisible: true,
            isTouch: ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0),
            isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,

            content: null,
            globalContent: null,
            modalContent: null,
            trads: null,

            currentPath: '',
            component: '',
            dataSrc: '',
            modalDataSrc: '',
            lang: getCookies('lang') !== '' ? getCookies('lang') : 'fr',
            baseApiUrl: 'http://localhost:8888/admin/wp-json/api/',
            URL: document.URL,

            magmaContent: null,

            color: ['#ffffff', '#ffffff', '#ffffff', '#ffffff'],

            modalProject:
            {
                isActive: false,
                activeIndex: 0,
                content: null,
            },

            homeDataSrc: null,
            isMagmaFiltered: false,
            isWheelDisable: false,

            from: null
        }
    },

    created()
    {
        this._lastScrollTop = 0

        const host = window.location.hostname

        if(host === 'edouardfrancois.dev6.colorz.fr')
        {
            this.baseApiUrl = 'http://edouardfrancois.dev6.colorz.fr/admin/wp-json/api/'
        }
        else if(host === 'localhost')
        {
            this.baseApiUrl = 'http://edouardfrancois.dev6.colorz.fr/admin/wp-json/api/'
        }
        else if(host === 'edouardfrancois.staging6.colorz.fr')
        {
            this.baseApiUrl = 'http://edouardfrancois.staging6.colorz.fr/admin/wp-json/api/'
        }
        else if(host === 'elastic.wcloud.colorz.fr')
        {
            this.baseApiUrl = 'http://elastic.wcloud.colorz.fr/admin/wp-json/api/'
        }
        else if(host === 'edfr.wcloud.colorz.fr')
        {
            this.baseApiUrl = 'https://edfr.wcloud.colorz.fr/admin/wp-json/api/'
        }
        else if(host.indexOf('edouardfrancois.com') > -1)
        {
            this.baseApiUrl = 'https://www.edouardfrancois.com/admin/wp-json/api/'
        }

        this.$body = document.body

        if(this.isTouch)
        {
            this.$body.classList.add('is-touch')
        }

        this._isTouchEnable = true


        if(getCookies('tooltip') && getCookies('tooltip') === 'true')
        {
            this.isTooltipVisible = false
        }

        this.eventHub.$on('toggle:modalProject', this.onToggleModalProject)
        this.eventHub.$on('destroy:virtualScroll', this.onDestroyVirtualScroll)
        this.eventHub.$on('set:virtualScroll', this.setVirtualScroll)
        this.eventHub.$on('home:filter', this.onFilter)
        this.eventHub.$on('set:magmaContent', this.setMagmaContent)
        this.eventHub.$on('selection:openForm', this.onOpenFormSelection)
        this.eventHub.$on('toggle:mobileNav', this.onToggleMobileNav)
        this.eventHub.$on('disable:touch', this.onDisableTouch)
        this.eventHub.$on('enable:touch', this.onEnableTouch)

        document.addEventListener('scroll', this.onScroll)
        document.addEventListener('keydown', this.onKeydown)

        window.addEventListener('resize', this.onResize)
    },

    mounted()
    {
        this.onResize()
        this.onTick()

        setTimeout(() =>
        {
            this.onRouteChange(this.$route)
        }, 10)
    },

    methods:
    {
        getScrollDirection(y)
        {
            if(y > this._lastScrollTop)
            {
                if(this.scrollDirection !== -1)
                {
                    this.scrollDirection = -1
                    this.eventHub.$emit('scrollDirection:change')
                }
            }

            if(y < this._lastScrollTop)
            {
                if(this.scrollDirection !== 1)
                {
                    this.scrollDirection = 1

                    this.eventHub.$emit('scrollDirection:change')
                }
            }

            this._lastScrollTop = y
        },

        onRouteChange(to, from)
        {
            this.URL = document.URL

            if(from)
            {
                this.from = from
                this.isFirstLoading = false
                this.$el.classList.remove('is-' + from.name)
            }

            if(to.name === 'my-selection' && !from)
            {
                if(this.getURLParameter('posts'))
                {
                    setCookies('selections', this.getURLParameter('posts'), 10)
                }
            }

            this.$el.classList.add('is-' + to.name)


            if(to.meta.isModal)
            {
                if(from)
                {
                    this.isSwitchinModal = from && from.meta.isModal

                    this.openModal()
                    this.modalDataSrc = this.baseApiUrl + this.lang + '/' + to.name + '/' + to.params.postId
                    this.$body.classList.add('u-overflow-h')
                }
                else
                {
                    this.createMagma(this.baseApiUrl + this.lang + '/' + to.name + '/' + to.params.postId)
                }
            }
            else
            {
                if(from && from.meta.isModal && to.name === this.currentPath)
                {
                    this.closeModal()
                    this.$body.classList.remove('u-overflow-h')
                }
                else
                {
                    if(from && from.meta.isModal)
                    {
                        this.closeModal()
                        this.$body.classList.remove('u-overflow-h')
                    }

                    this.$body.classList.add('u-overflow-h')
                    this.currentPath = to.name

                    this.onToggleLoader();

                    this.isDataLoaded = false
                    this.component = to.meta.component
                    this.dataSrc = ''

                    if(to.name === 'home') {
                        this.$el.classList.remove('is-loaded');
                    }

                    this.$nextTick(() =>
                    {
                        const postId = to.params.postId ? to.params.postId : ''
                        const query = to.query.posts ? '?posts=' + to.query.posts : ''

                        if(to.name === 'home' && this.isMagmaFiltered)
                        {
                            this.dataSrc = this.baseApiUrl + this.lang + this.homeDataSrc
                        }
                        else
                        {
                            this.dataSrc = this.baseApiUrl + this.lang + to.meta.dataSrc + postId + query
                        }
                    })


                    // wait for the loader transition animation
                    const timerDuration = this.isFirstLoading ? 0 : 500

                    setTimeout(() =>
                    {
                        if(to.name === 'home' && !this.isTouch)
                        {
                            this.$body.classList.add('is-fixed')
                            this.setVirtualScroll()
                        }
                        else
                        {
                            if(this.$body.classList.contains('is-fixed'))
                            {
                                this.$body.classList.remove('is-fixed')
                                this.onDestroyVirtualScroll()
                            }
                        }

                        if(this.isMobileNavActive)
                        {
                            this.onToggleMobileNav()
                        }

                        window.scrollTo(0, 0)

                        this.$el.classList.remove('is-ready')
                        this.$body.classList.remove('u-overflow-h')

                        if(this.isTouch)
                        {
                            this._isTouchEnable = true
                        }
                    }, timerDuration)
                }
            }
        },

        createMagma(modalDataSrc)
        {
            this.$body.classList.add('u-overflow-h')
            this.currentPath = 'home'

            this.onToggleLoader()

            this.isDataLoaded = false
            this.component = 'app-page-home'
            this.dataSrc = ''

            this.$nextTick(() =>
            {
                this.dataSrc = this.baseApiUrl + this.lang + '/home?instagram&medias=&projects=&article=&team=&agency'
            })

            this._magmaModalDataSrc = modalDataSrc

            this.isMagmaCreatedForModal = true

            this.openModal()
        },

        onFilter(dataSrc)
        {
            this.homeDataSrc = dataSrc

            if(this.homeDataSrc.includes('medias') && this.homeDataSrc.includes('projects') && this.homeDataSrc.includes('article') && this.homeDataSrc.includes('medias') && this.homeDataSrc.includes('instagram') && this.homeDataSrc.includes('team') && this.homeDataSrc.includes('agency'))
            {
                this.isMagmaFiltered = false
            }
            else
            {
                this.isMagmaFiltered = true
            }
        },

        setMagmaContent(content)
        {
            this.magmaContent = content
        },

        setVirtualScroll()
        {
            if(!this.isVirtualScrollActive && !this.isTouch)
            {
                this._lastScrollTop = 0
                this.virtualScroll = 0
                this.scrollDirection = 1

                this._scroll = new VirtualScroll({
                    firefoxMultiplier: 30
                })

                this._scroll.on(this.onVirtualScroll, this)

                this.isVirtualScrollActive = true
            }

        },

        onVirtualScroll(event)
        {
            clearTimeout(this._timer)

            this.isUserScrolling = true

            this.virtualScroll = event.y

            this.getScrollDirection(event.y)

            this._timer = setTimeout(() =>
            {
                this.isUserScrolling = false
            }, 1200)
        },

        onDisableTouch()
        {
            this._isTouchEnable = false
        },

        onEnableTouch()
        {
            this._isTouchEnable = true
        },

        onTouchMove(event)
        {
            if(!this._isTouchEnable)
            {
                event.preventDefault()
            }
        },

        onDestroyVirtualScroll()
        {
            if(this.isVirtualScrollActive)
            {
                this._scroll.off(this.onVirtualScroll, this)
                this._scroll.destroy()

                this._scroll = null

                this.isVirtualScrollActive = false
            }
        },

        onScroll()
        {
            this.scrollTop = document.scrollingElement.scrollTop || document.documentElement.scrollTop

            if(this.isSmallScreen)
            {

                this.getScrollDirection(this.scrollTop)


                if(this.scrollTop > 100)
                {
                    if(this.scrollDirection === -1)
                    {
                        this.$el.classList.add('is-header-hidden')
                    }
                    else
                    {
                        this.$el.classList.remove('is-header-hidden')
                    }
                }
                else
                {
                    this.$el.classList.remove('is-header-hidden')
                }
            }
        },

        onOpenFormSelection()
        {
            this.$el.classList.remove('is-header-hidden')
        },

        onKeydown(event)
        {
            this.eventHub.$emit('keydown', event.keyCode)
        },

        onResize()
        {
            this.window.width = window.innerWidth
            this.window.height = window.innerHeight

            this.isSmallScreen = this.window.width <= 770

            this.eventHub.$emit('window:resize')
        },

        onTick()
        {
            this.currScrollTop += (this.scrollTop - this.currScrollTop) * .1

            this.eventHub.$emit('window:tick')
            requestAnimationFrame(this.onTick)
        },

        onToggleNav()
        {
            this.isNavActive = !this.isNavActive
            this.$el.classList.toggle('is-nav-active')
        },

        onToggleLoader()
        {
            this.isLoaderActive = !this.isLoaderActive
            this.$el.classList.toggle('is-loader-active')
        },

        openModal()
        {
            this.isModalPostActive = true
            this.$el.classList.add('is-loader-active')
        },

        closeModal()
        {
            this.isModalPostActive = false
            this.isModalDataLoaded = false
            this.modalDataSrc = ''
            this.$body.classList.remove('u-overflow-h')
        },

        onPageReady()
        {
            this.$el.classList.add('is-loaded');
            if(this.isMagmaCreatedForModal)
            {
                this.modalDataSrc = this._magmaModalDataSrc
                this.$body.classList.add('u-overflow-h')
            }
            else
            {
                this.onToggleLoader()
            }

            // wait for the loader to be hidden
            setTimeout(() =>
            {
                if(this.currentPath === 'encyclopedia-detail')
                {
                    this.$el.classList.add('is-encyclopedia-visited')
                }

                this.$el.classList.add('is-ready')
            }, 500)
        },

        onDataLoaded(resp)
        {
            if(this.$route.name === 'project')
            {
                if(!resp.ID)
                {
                    this.onDataError()
                    this.$nextTick(() =>
                    {
                        window.location.reload()
                    })
                }
            }

            // if(this.$route.meta.isModal)
            // {
            //     if(!resp.ID)
            //     {
            //         this.onDataError()

            //         return
            //     }
            // }

            this.isDataLoaded = true
            this.content = resp
        },

        onGlobalDataLoaded(resp)
        {
            this.globalContent = resp
            this.isGlobalDataLoaded = true

            this.color[0] = this.globalContent.settings.couleur_projets
            this.color[1] = this.globalContent.settings.couleur_articles
            this.color[2] = this.globalContent.settings.couleur_medias
            this.color[3] = this.globalContent.settings.couleur_maison
        },

        onTradsLoaded(resp)
        {
            this.trads = resp
        },

        onDataError()
        {
            this.$router.push('/404')
        },

        onModalDataLoaded(resp)
        {
            if(!resp)
            {
                this.onDataError()
                this.$nextTick(() =>
                {
                    window.location.reload()
                })
            }

            this.modalContent = resp
            this.isModalDataLoaded = true
            this.isSwitchinModal = false
            this.$body.classList.add('u-overflow-h')

            if(this.isMagmaCreatedForModal)
            {
                this.isMagmaCreatedForModal = false
                this.onToggleLoader()
            }
            else
            {
                this.$el.classList.remove('is-loader-active')
            }
        },

        onToggleModalProject(index, content)
        {
            if(content)
            {
                this.modalProject.isActive = true
                this.modalProject.activeIndex = index
                this.modalProject.content = content
                this.$body.classList.add('u-overflow-h')
            }
            else
            {
                this.modalProject.isActive = false
                this.$body.classList.remove('u-overflow-h')
            }
        },

        onToggleMobileNav()
        {
            this.isMobileNavActive = !this.isMobileNavActive
            this.$el.classList.toggle('is-mobile-nav-active')

            if(this.isMobileNavActive)
            {
                this.onDisableTouch()
            }
            else
            {
                this.onEnableTouch()
            }
        },

        onSwitchLang()
        {
            if(this.lang === 'en')
            {
                setCookies('lang', 'fr', 10)
            }
            else
            {
                setCookies('lang', 'en', 10)
            }

            this.$nextTick(() =>
            {
                window.location.reload()
            })
        },

        onCloseTooltip()
        {
            this.isTooltipVisible = false
            setCookies('tooltip', true, 10)
        },

        getURLParameter(name)
        {
          return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/_application/script.js